// extracted by mini-css-extract-plugin
export default {"datePickerLabel":"datePicker_datePickerLabel__dRDEe"};